/* Copyright (c) 2020-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

export type Options = {
  value: string;
  label?: string;
};

export const enum Mode {
  INCLUDES = "INCLUDES",
  EXCLUDES = "EXCLUDES",
}

export type Item = {
  label?: string | null;
  subLabel?: string | null;
  value?: string | null;
  subCheckboxes?: SubItem[] | null;
};

export type SubItem = {
  label?: string | null;
  subLabel?: string | null;
  value?: string | null;
};

export type Option = string | Options;
export type OptionKey = keyof Options;

export type ListWithInputsSelections = {
  checkboxes: string[];
  inputsByCheckbox: Record<string, string[]>;
};

export type ListWithInputsItem = Omit<Item, "subCheckboxes"> & {
  noInputs?: boolean;
  allowMultipleInputs?: boolean;
  addInputButtonText?: string;
  inputPlaceholderText?: string;
};
